<template>
  <div class="video-cropper">
    <div
      v-if="videoUrl"
      class="video-cutter-box"
    >
      <div
        ref="wrapperDom"
        class="video-wrapper"
      >
        <crop-editor
          v-if="cropType === 'crop'"
          ref="cropEditor"
          :video-url="videoUrl"
          :volume="volume"
          :matrix="matrix"
          :ratio="ratio.value"
          :rotate="rotate"
          @canPlay="canPlayfunc"
          @ended="playEnd"
          @timeupdate="timeupdate"
        ></crop-editor>
        <canvas-editor
          v-if="cropType === 'canvas'"
          ref="canvasEditor"
          :video-url="videoUrl"
          :volume="volume"
          :matrix="matrix"
          :rotate="rotate"
          :ratio="ratio.value"
          @canPlay="canPlayfunc"
          @ended="playEnd"
          @timeupdate="timeupdate"
        ></canvas-editor>
      </div>
      <div class="video-btn">
        <videoChange @changeVideo="changeVideo"></videoChange>
        <videoControl
          :duration="duration"
          :now-time="nowTime"
          :playing="playing"
          @play="videoPlay"
        ></videoControl>
        <div class="video-volume-water">
          <div class="video-water">
            <videoVolume @changeData="changeVolume"></videoVolume>
            <span>不加水印</span>
            <el-switch
              v-model="noWater"
              active-color="#2f58fe"
              inactive-color="#E0E2EA"
              :width="30"
              @change="changeWater"
            ></el-switch>
            <div class="temporary-nowater">
              <iconfont
                name="#icon11-111xianmian"
                font-size="30px"
              ></iconfont>
            </div>
          </div>
        </div>
      </div>
      <div class="video-time-area">
        <crop-timeline
          :info="timelineObj"
          @changeData="changeData"
        ></crop-timeline>
      </div>
      <div class="video-set-area">
        <div
          class="cropper-set-trans"
          @click="rotateVideo"
        >
          <iconfont
            class="normal"
            name="#icon15-11xuanzhuanshipin"
            font-size="16px"
            color="#a7aab6"
          ></iconfont>
          <iconfont
            class="hover"
            name="#icon15-11xuanzhuanshipin"
            font-size="16px"
            color="#2F58FE"
          ></iconfont>
          <span>视频旋转</span>
        </div>
        <div class="cropper-set-ratio">
          <span>设置比例</span>
          <drop-down-menu
            v-model="ratio"
            class="selectionFormat"
            :menu-list="ratioList"
          ></drop-down-menu>
        </div>
        <div
          class="cropper-set-crop"
          :class="{ active: cropType === 'crop' }"
          @click="changeType('crop')"
        >
          裁剪模式
        </div>
        <el-tooltip
          content="画布模式不支持自由比例，请更改比例设置"
          :disabled="ratio.value > -1"
        >
          <div
            class="cropper-set-canvas"
            :class="{ active: cropType === 'canvas', disable: ratio.value < 0 }"
            @click="changeType('canvas')"
          >
            画布模式
          </div>
        </el-tooltip>
        <div
          class="cropper-set-start"
          @click="startCrop"
        >
          开始处理
        </div>
      </div>
    </div>
    <div
      v-else
      class="video-file-add"
    >
      <blankAdd
        v-if="!hasFile"
        @changeFiles="changeFile"
      ></blankAdd>
      <uploadProgress
        v-else
        :percent="uploadPercent"
        @cancelHttp="cancelHttp"
      ></uploadProgress>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'VideoCropper',
  components: {
    BlankAdd: () => import('@/components/global/blankAdd.vue'),
    UploadProgress: () => import('@/components/videoCutter/uploadProgress.vue'),
    VideoChange: () => import('@/components/videoCutter/videoChange.vue'),
    VideoControl: () => import('@/components/videoCutter/videoControl.vue'),
    VideoVolume: () => import('@/components/videoCutter/videoVolume.vue'),
    CropTimeline: () => import('@/components/videoCropper/cropTimeline.vue'),
    CropEditor: () => import('@/components/videoCropper/cropEditor.vue'),
    CanvasEditor: () => import('@/components/videoCropper/canvasEditor.vue'),
    DropDownMenu: () => import('@/components/common/dropDownMenu')
  },
  data() {
    return {
      cropType: 'crop', // canvas
      nowTime: 0,
      duration: 10,
      playing: false,
      canPlay: false,
      noWater: false,
      volume: 1,
      videoUrl: '',
      sourceUrl: '',
      blobUrls: [],
      hasFile: false,
      uploadPercent: 0,
      source: {},
      matrix: {
        w: 0,
        h: 0,
        x: 0,
        y: 0
      },
      timelineObj: { step: 0.1, min: 0, max: 10, val: 0 },
      rotate: 0,
      ratio: 1,
      ratioList: [
        {
          name: '自由比例',
          description: '',
          value: -1,
          disable: false //裁剪模式false ,画布模式true
        },
        {
          name: '9:16',
          description: '抖音(竖)',
          value: 9 / 16
        },
        {
          name: '16:9',
          description: '视频号(横)',
          value: 16 / 9
        },
        {
          name: '6:7',
          description: '视频号(竖)',
          value: 6 / 7
        },
        {
          name: '3:4',
          description: '淘宝视频',
          value: 3 / 4
        },
        {
          name: '1:1',
          description: '正方形',
          value: 1
        },
        {
          name: '原始(默认值)',
          description: '',
          value: 0
        }
      ],
      clickOne: false,
      fileSize: 0,
      sourceType: '',
      addVideoAction: false
    };
  },
  computed: {
    ...mapGetters({
      watermark: 'common/watermark'
    })
  },
  created() {
    this.$bus.on('changeFiles', this.changeFile);
  },
  mounted() {
    window.addEventListener('resize', this.resize);
    if (this.$route.query.pipe === '1') {
      let data = this.$store.getters['completed/getPipeFiles'];
      if (data.length) {
        this.sourceType = '其他工具';
        this.addVideoAction = true;
        this.fileSize = data[0].size;
        this.canPlay = false;
        this.sourceUrl = data[0].url;
        this.videoUrl = this.$.handleAssetsUrl(data[0].url);
        this.name = data[0].name;
        this.$store.commit('uploader/setVideoUrl', data[0].url);
      }
    }
    this.ratio = this.ratioList[this.ratioList.length - 1];

    this.$store.commit('common/setEditing', false);
    this.$nextTick(() => {
      this.getMatrix();
      this.noWater = this.watermark.clearWatermark ? true : false;
    });

    let shot = this.$store.getters['uploader/videoUrlShot'];
    if (shot.url && !(this.$route.query || {}).id && !(this.$route.query || {}).pipe) {
      this.changeFile(shot);
    }
  },
  beforeDestroy() {
    this.$bus.on('changeFiles', this.changeFile);
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    async changeFile(data) {
      if (data.blob) {
        this.hasFile = true;
        let success = await this.uploadTask(data.blob);
        if (!success) {
          this.hasFile = false;
          return;
        }
        this.hasFile = false;
        this.canPlay = false;
        this.sourceType = '本地上传';
        this.addVideoAction = true;
        this.fileSize = data.blob.size;
        this.videoUrl = window.URL.createObjectURL(data.blob);
        this.blobUrls.push(this.videoUrl);
      } else if (data.url) {
        this.canPlay = false;
        this.sourceType = data.fileType === 26 ? '视频库' : '作品库';
        this.addVideoAction = true;
        this.fileSize = data.size;
        this.sourceUrl = data.url;
        this.videoUrl = this.$.handleAssetsUrl(data.url);
      }
      this.name = data.name || data.title;
      this.$nextTick(() => {
        this.videoUrl && this.getMatrix();
      });
    },
    changeVideo() {
      let fileObj = null;
      this.$modal.show('selectModal', {
        onFile: (file) => {
          fileObj = file;
          // 读取到本地文件时回调
        },
        onUrl: (url) => {
          // 文件全送到云端时回调
          this.ratio = this.ratioList[this.ratioList.length - 1];
          this.rotate = 0;
          this.canPlay = false;
          this.sourceType = '本地上传';
          this.addVideoAction = true;
          this.fileSize = fileObj.size;
          if (fileObj) {
            this.videoUrl = window.URL.createObjectURL(fileObj);
            this.blobUrls.push(this.videoUrl);
            this.name = fileObj.name;
            fileObj = null;
          } else {
            this.videoUrl = this.$.handleAssetsUrl(url);
          }
          this.sourceUrl = url;
          this.$modal.hide('selectModal');
        },
        onInfo: (info) => {
          // 点击我的作品打卡列表弹窗，选一个作品然后点击确定时回调
          if (info.url) {
            this.ratio = this.ratioList[this.ratioList.length - 1];
            this.rotate = 0;
            this.canPlay = false;
            this.sourceType = info.fileType === 26 ? '视频库' : '作品库';
            this.addVideoAction = true;
            this.fileSize = info.size;
            this.sourceUrl = info.url;
            this.name = info.title;
            this.videoUrl = this.$.handleAssetsUrl(info.url);
            this.$modal.hide('selectModal');
          }
        }
      });
    },
    canPlayfunc(data) {
      if (this.canPlay) return;
      this.nowTime = 0;
      this.duration = data;
      this.timelineObj.val = 0;
      this.timelineObj.max = data;
      this.canPlay = true;
      this.playing = false;
      this.$store.commit('common/setEditing', true);
      if (this.addVideoAction) {
        this.$sensors.track('toolVideoUpload', {
          tool_type: '裁剪宝',
          video_source: this.sourceType,
          video_duration: data,
          video_size: this.fileSize > 1024 ? this.fileSize / 1024 / 1024 : this.fileSize
        });
        this.addVideoAction = false;
      }
    },
    videoPlay() {
      if (!this.canPlay) return;
      let ob = {};
      if (this.playing) {
        ob.play = false;
      } else {
        ob.play = true;
        if (this.nowTime >= this.duration) {
          ob.time = 0;
        }
      }
      this.playing = !this.playing;

      this.$refs[this.cropType + 'Editor'].videoPlay(ob);
    },
    changeVolume(volume) {
      this.volume = volume / 100;
    },
    changeType(type) {
      if (type === 'canvas' && this.ratio.value < 0) return;
      if (type === 'canvas') {
        this.ratioList[0].disable = true;
      } else {
        this.ratioList[0].disable = false;
      }
      if (this.cropType !== type) {
        this.cropType = type;
        this.canPlay = false;
      }
    },
    async uploadTask(file) {
      // 判断上传限制
      if (file.type !== 'video/mp4') {
        this.$message({
          message: '只支持MP4格式的文件',
          type: 'error',
          center: true
        });
        return;
      } else if (file.size > 200 * 1024 * 1024) {
        this.$message({
          message: `文件"${file.name}"大小超过限制`,
          type: 'error',
          center: true
        });
        return;
      } else if ((await this.$.getDuration(file)) > 3600) {
        this.$message({
          message: `文件"${file.name}"时长超过限制`,
          type: 'error',
          center: true
        });
        return;
      }

      // 用于取消上传
      let CancelToken = this.$http.CancelToken;
      this.source = CancelToken.source();
      let filesize = file.size;
      let perSize = 6 * 1024 * 1024; //每片大小
      let chunkNumbers = Math.ceil(filesize / perSize); // 总片数，向上取整
      let start = 0; //分片开头
      let end = 0; //分片结尾
      let filename = new Date().getTime() + '.mp4';
      let uploadCompletedNumbers = 0;

      for (let i = 0; i < chunkNumbers; i++) {
        start = end;
        end = start + perSize;
        if (end > filesize) {
          end = filesize;
        }
        const chunk = file.slice(start, end);
        const formData = new FormData();
        formData.append('files[]', chunk, filename);
        let result = await this.uploadChunk({
          formData: formData,
          index: i,
          perSize: perSize,
          filesize: filesize,
          chunkNumbers: chunkNumbers
        });
        if (result) {
          uploadCompletedNumbers++;
          this.uploadPercent = (uploadCompletedNumbers / chunkNumbers) * 100;
        } else {
          break; //一个分片上传失败，就判断为整体失败
        }
      }

      if (uploadCompletedNumbers == chunkNumbers) {
        let result = await this.mergeBlock({ filename: filename, chunkNumber: chunkNumbers });
        if (result) {
          this.sourceUrl = result.filename;
          return true;
        }
      }

      this.$message({
        message: '上传失败',
        type: 'error',
        center: true
      });
    },
    uploadChunk(query) {
      return new Promise((resolve) => {
        this.$http({
          url: `/upload/fileBlock?currentChunkSize=${query.perSize}&index=${query.index}&chunkSize=${query.filesize}&totalChunks=${query.chunkNumbers}`,
          method: 'post',
          data: query.formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          cancelToken: this.source.token,
          timeout: 10 * 60 * 1000
        })
          .then((res) => {
            if (res.status === 200 && res.data.code === 200) {
              resolve(res.data.data);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    mergeBlock(body) {
      return new Promise((resolve) => {
        this.$http
          .post('/upload/mergeBlock', body)
          .then((res) => {
            if (res.status === 200 && res.data.code === 200) {
              this.$store.commit('uploader/setVideoUrl', res.data.data.filename);
              resolve(res.data.data);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    cancelHttp() {
      // 取消上传
      this.source.cancel('用户取消上传');
      this.videoUrl = '';
      this.sourceUrl = '';
      this.canPlay = false;
      this.hasFile = false;
    },
    resize() {
      this.getMatrix();
    },
    getMatrix() {
      if (!this.$refs.wrapperDom) return;
      let { height: h, top: y, width: w, left: x } = this.$refs.wrapperDom.getBoundingClientRect();
      this.matrix.w = w;
      this.matrix.h = h;
      this.matrix.x = x;
      this.matrix.y = y;
    },
    timeupdate(time) {
      if (this.playing) {
        this.nowTime = time;
        this.timelineObj.val = this.nowTime;
      }
    },
    changeData(data) {
      if (data.type !== 'change') return;
      if (data.action === 'handle' || data.action === 'click') {
        this.nowTime = data.val;
        this.timelineObj.val = data.val;
        this.$refs[this.cropType + 'Editor'].videoPlay({ play: this.playing, time: data.val });
      }
    },
    playEnd() {
      this.playing = false;
      this.nowTime = this.duration;
      this.timelineObj.val = this.nowTime;
    },
    rotateVideo() {
      let rotate = this.rotate + 90;
      if (rotate >= 360) {
        this.rotate = 0;
      } else {
        this.rotate = rotate;
      }
      this.$bus.emit('popup_close', { type: 'all' });
    },
    changeRatio(ratio) {
      if (typeof ratio === 'number') {
        this.ratio = ratio;
      } else {
        this.ratio = 0;
      }
      this.$bus.emit('popup_close', { type: 'all' });
    },
    async startCrop() {
      if (this.clickOne) return;
      this.clickOne = true;
      let body = {
        type: 4,
        key: this.sourceUrl,
        rotation: Math.round(this.rotate / 90),
        nonwatermark: this.noWater ? 1 : 0
      };
      if (this.cropType === 'canvas') {
        body.mode = 1;
        let obj = this.$refs.canvasEditor.getPostInfo();
        Object.assign(body, obj);
      } else {
        body.mode = 0;
        let obj = this.$refs.cropEditor.getPostInfo();
        Object.assign(body, obj);
      }

      let result = await this.cropPost(body);
      if (result) {
        this.$sensors.track('toolVideoProcess', {
          tool_type: '裁剪宝',
          video_source: this.sourceType
        });
        this.$bus.emit('maskLayer', {
          show: true,
          type: 'cropperMask',
          info: {
            name: this.name,
            taskId: result.taskId,
            key: result.key,
            newkey: result.newkey,
            thumbnailkey: result.thumbnailkey,
            duration: this.duration
          }
        });
      } else {
        this.$message({
          message: '裁剪失败',
          type: 'error',
          center: true
        });
      }
      this.clickOne = false;
    },
    cropPost(body) {
      return new Promise((resolve) => {
        this.$http
          .post('/onlineTask?type=4', body)
          .then((res) => {
            if (res.status === 200 && res.data.code === 200) {
              resolve(res.data.data);
            } else {
              resolve(false);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    changeWater(value) {
      this.$store.commit('common/setClearWatermark', value);
      if (value) {
        localStorage.setItem('watermark-switch', true);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.video-cropper {
  width: 100%;
  height: 100%;
  padding: 17px 65px 0 74px;
  background-color: #f6f7fb;
  font-size: 14px;
  color: #333333;

  * {
    user-select: none;
  }
}
.video-cutter-box,
.video-file-add {
  width: 100%;
  height: calc(100% - 54px);
}
.video-wrapper {
  width: 100%;
  height: calc(100% - 229px);
  min-width: 50px;
  min-height: 30px;
}
.video-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px auto 44px;
}
.video-water {
  position: relative;
  display: flex;
  align-items: center;

  span {
    margin-left: 30px;
    margin-right: 7px;
  }

  .temporary-nowater {
    position: absolute;
    width: 30px;
    height: 14px;
    top: -18px;
    right: -20px;
  }
}
.video-set-area {
  width: 100%;
  margin-top: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cropper-set-trans {
  width: 108px;
  height: 30px;
  line-height: 28px;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 1px 2px 5px 0px rgba(124, 124, 124, 0.13);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  > span {
    margin-left: 8px;
  }

  .hover {
    display: none;
  }

  &:hover {
    color: #3058fe;
    border-color: #3058fe;

    .normal {
      display: none;
    }
    .hover {
      display: block;
    }
  }
}
.cropper-set-ratio {
  width: 254px;
  margin-left: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .selectionFormat {
    width: 180px;
    height: 40px;
    margin-left: 10px;
  }
}
.cropper-set-crop,
.cropper-set-canvas {
  width: 120px;
  height: 40px;
  line-height: 38px;
  margin-left: 30px;
  background-color: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  cursor: pointer;

  &.disable {
    color: #d5d5d5;
    border-color: #d5d5d5;
    cursor: not-allowed;
  }

  &:not(.disable):hover,
  &:not(.disable).active {
    color: #3058fe;
    border-color: #3058fe;
  }
}
.cropper-set-start {
  width: 120px;
  height: 40px;
  line-height: 38px;
  margin-left: 40px;
  color: #ffffff;
  background-color: #3058fe;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #3d7dff;
  }
}
@media (max-width: 1600px) {
  .cropper-set-trans {
    width: 90px;
    height: 26px;
    line-height: 26px;
    border-radius: 12px;
    font-size: 12px;

    > svg {
      transform-origin: center;
      transform: scale(0.8);
    }

    > span {
      margin-left: 4px;
    }
  }
  .cropper-set-ratio {
    width: 200px;
    margin-left: 18px;

    .selectionFormat {
      width: 134px;
      height: 30px;
      margin-left: 6px;
      font-size: 12px;
    }
  }
  .cropper-set-crop,
  .cropper-set-canvas {
    width: 84px;
    height: 30px;
    line-height: 30px;
    margin-left: 20px;
    font-size: 12px;
  }
  .cropper-set-start {
    width: 84px;
    height: 30px;
    line-height: 30px;
    margin-left: 20px;
    font-size: 12px;
  }
  .video-water {
    span {
      margin-left: 10px;
      margin-right: 5px;
      font-size: 12px;
      margin-top: 1px;
    }
  }
  .temporary-nowater {
    width: 26px;
    height: 12px;

    > svg {
      transform-origin: center;
      transform: scale(0.9);
    }
  }
}
</style>
<style lang="scss">
.video-cropper {
  .el-switch__core {
    height: 16px;

    &:after {
      width: 14px;
      height: 14px;
      top: 0;
    }
  }
  .el-switch.is-checked .el-switch__core::after {
    margin-left: -14px;
  }

  .el-slider__button {
    border: 0px !important;
    box-shadow: 0px 5px 30px 0px rgba(22, 64, 234, 0.16);
  }
  .el-slider__runway {
    .el-slider__bar {
      background: #2f58fe;
    }
  }
}
</style>
